class AddToCompare extends HTMLElement {
  connectedCallback() {
    this.maxItems = window.innerWidth < 750 ? 3 : 4;
    this.variantId = this.dataset.variantId;
    // Remove any query parameters from the product URL so we can safely append
    // our own when fetching compare data
    this.productUrl = (this.dataset.productUrl || '').split('?')[0];
    this.collectionHandle = this.dataset.collectionHandle || 'default';

    this.addEventListener('click', this.onClick.bind(this));

    document.addEventListener('compare-updated', (e) => {
      if (!this.variantId || e.detail.handle !== this.collectionHandle) return;
      const exists = e.detail.items.some((i) => i.id === this.variantId);
      this.classList.toggle('compare-added', exists);
    });

    if (
      this.variantId &&
      this.getItems().some((i) => i.id === this.variantId)
    ) {
      this.classList.add('compare-added');
    }
  }

  getAll() {
    try {
      const data = JSON.parse(sessionStorage.getItem('compareItems'));
      if (!data) return {};
      if (Array.isArray(data)) {
        return { default: data };
      }
      return data;
    } catch (err) {
      return {};
    }
  }

  getItems() {
    const all = this.getAll();
    return all[this.collectionHandle] || [];
  }

  saveItems(items) {
    const all = this.getAll();
    all[this.collectionHandle] = items;
    sessionStorage.setItem('compareItems', JSON.stringify(all));
  }

  onClick(event) {
    event.preventDefault();
    if (!this.variantId) return;

    let items = this.getItems();
    const exists = items.some((i) => i.id === this.variantId);

    if (exists) {
      items = items.filter((i) => i.id !== this.variantId);
      this.classList.remove('compare-added');
    } else {
      if (items.length >= this.maxItems) {
        alert(`You can compare only ${this.maxItems} products`);
        return;
      }
      items.push({ id: this.variantId, url: this.productUrl });
      this.classList.add('compare-added');
    }

    this.saveItems(items);

    document.dispatchEvent(
      new CustomEvent('compare-updated', { detail: { items, handle: this.collectionHandle } })
    );
  }
}

customElements.define('add-to-compare', AddToCompare);
